import React, { useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { IoIosRemoveCircleOutline } from "react-icons/io";
import { useSelector } from "react-redux";
import CallDispositionModal from "./CallDispositionModal";

const AmeyoBot = ({
  minimized,
  showDialog,
  closeDialog,
  showPanel,
  closePanel,
  showAmeyoPanel,
}) => {
  const userDetails = useSelector(
    (state) => state.user.userDetails || { UserDetails: {} }
  );

  const fullPhone = userDetails.UserDetails.phone;
  const assoPhone = fullPhone
    ? fullPhone.length > 10
      ? fullPhone.slice(-10)
      : fullPhone
    : "1234567890";

  const location = useLocation();
  // const [showAmeyoPanel, setShowAmeyoPanel] = useState(false);
  // const [minimized, setMinimized] = useState(false);
  const [ameyoLoaded, setAmeyoLoaded] = useState(false);
  const [showCallDispositionModal, setShowCallDispositionModal] =
    useState(false);
  const [leadPhone, setLeadPhone] = useState(null);
  const iframeRef = useRef(null);
  const ameyoPass = localStorage.getItem("ameyoPass");

  const isAmeyoBot =
    location.pathname.includes("mdp-reports") ||
    location.pathname.includes("leadPreview");
  const ameyoBaseUrl = process.env.REACT_APP_AMEYO_BASE_URL;

  useEffect(() => {
    if (showAmeyoPanel && !ameyoLoaded) {
      const script = document.createElement("script");
      script.src = `${ameyoBaseUrl}/ameyowebaccess/toolbar/js/ameyo-integration-v4_13.js`;
      script.async = true;
      script.onload = () => {
        setAmeyoLoaded(true);
        if (window.ameyo && window.ameyo.integration) {
          window.ameyo.integration.registerCustomFunction(
            "showCrm",
            handleIncomingCall
          );
          window.ameyo.integration.registerCustomFunction("doDial", handleDial);
        }
      };
      document.body.appendChild(script);

      return () => {
        document.body.removeChild(script);
      };
    }
  }, [showAmeyoPanel, ameyoLoaded]);

  useEffect(() => {
    if (ameyoLoaded) {
      window.addEventListener("message", handleAmeyoEvent);
    }

    return () => {
      if (ameyoLoaded) {
        window.removeEventListener("message", handleAmeyoEvent);
      }
    };
  }, [ameyoLoaded]);

  const handleAmeyoEvent = (event) => {
    let data;
    try {
      data =
        typeof event.data === "string" ? JSON.parse(event.data) : event.data;
    } catch (error) {
      console.error("Error parsing Ameyo message:", error);
      return;
    }

    console.log("Event: ", event);
    // console.log("Parsed data:", data);

    const { method, phone, requestId, additionalParams } = data;
    setLeadPhone(phone);
    console.log("voila", method);
    if (method === "showCrm" && phone) {
      handleIncomingCall(phone, additionalParams);
      // setCallData({ phone, ...additionalParameters });
      setShowCallDispositionModal(true);
    }
    if (method === "doDial") {
      console.log("call method found.");
      handleDoDial();
    }

    if (method === "intializeLoginCredentials") {
      const ameyoAutoLoginStatus = localStorage.getItem("ameyoAutoLogin");
      console.log(
        "ameyo auto LoginStatus before the do login ",
        ameyoAutoLoginStatus
      );
      if (ameyoAutoLoginStatus == "true") {
        console.log(
          "ameyo auto login status before do login handler",
          ameyoAutoLoginStatus
        );
        handleDoLogin();
      } else {
        console.log("auto login is off due to manual logout.");
      }
    }
  };

  const handleIncomingCall = (phone, additionalParameters) => {
    showDialog();
    showPanel();
    // setShowAmeyoPanel(true);
  };

  const handleDoDial = () => {
    console.log("modal opened after call");
    showDialog();
    showPanel();
    setShowCallDispositionModal(true);
  };

  const sendMessageToAmeyo = (type, payload) => {
    const message = JSON.stringify({ type, payload });
    if (iframeRef.current && iframeRef.current.contentWindow) {
      iframeRef.current.contentWindow.postMessage(
        message,
        ameyoBaseUrl.slice(0, -1)
      );
    }
  };

  const handleAmeyoAgent = () => {
    if (minimized) {
      showDialog();
    } else {
      showPanel();
      // setShowAmeyoPanel(true);
    }
  };

  const handleMinimize = () => {
    closeDialog();
  };

  const handleDial = (phoneNumber) => {
    if (window.ameyo && window.ameyo.integration) {
      sendMessageToAmeyo("DODIAL", { phoneNumber });
    } else {
      console.error("Ameyo integration not loaded");
    }
  };

  const handleDoLogin = () => {
    console.log("entered do login");

    if (window.ameyo && window.ameyo.integration) {

      if (userDetails?.UserDetails?.email) {

        window.ameyo.integration.doLogin(
          userDetails.UserDetails.email,
          ameyoPass,
          "auth.type.crm.http"
        );
        localStorage.setItem("ameyoAutoLogin", "false");
        console.log("Login attempt completed");
      } else {
        console.error("Missing email or decrypted password for login");
      }
    } else {
      console.error("Ameyo integration not available");
    }
  };

  if (isAmeyoBot) return null;

  // https://emergeapp4.ameyoemerge.in:8443/ameyowebaccess/toolbar-crm.htm
  // const iframeUrl = `${ameyoBaseUrl}/ameyowebaccess/toolbarLogin-vl.htm?origin=https://dev-ihd.mirae-asset.co.in/manageLeads&webRTCSession=true#`;

  // https://emergeapp4.ameyoemerge.in:8443/ameyowebaccess/toolbar-crm.htm?origin=https://kaizen.mstock.com/manageLeads&webRTCSession=true&email=@{User:EmailAddress,}&userId=@{User:EmailAddress,}&token=kndfon&AssociatedPhoneNumbers=@{User:AgentPhoneNumber,}

  // https://emergeapp4.ameyoemerge.in:8443/ameyowebaccess/toolbar-crm.htm?origin=https://kaizen.mstock.com/manageLeads&webRTCSession=true&email=ravindra.khushwaha@fv.com&userId=ravindra.khushwaha@fv.com&token=kndfon&AssociatedPhoneNumbers=6474635241
  const iframeUrl = `${ameyoBaseUrl}/ameyowebaccess/toolbar-crm.htm?origin=${process.env.REACT_APP_FE_ORIGIN}/manageLeads&webRTCSession=true&email=${userDetails.UserDetails.email}&userId=${userDetails.UserDetails.email}&token=kndfon&AssociatedPhoneNumbers=${assoPhone}`;
  return (
    <>
      {(minimized || !showAmeyoPanel) && (
        <div
          style={{
            height: "60px",
            width: "60px",
            position: "fixed",
            backgroundColor: "rgba(51, 51, 255)",
            color: "#ffffff",
            border: "1px solid #3A36DB",
            right: 30,
            bottom: 20,
            zIndex: 99999,
            borderRadius: 50,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            fontSize: "14px",
            boxShadow: "0 10px 20px rgba(0,0,0,0.5)",
            cursor: "pointer",
          }}
          onClick={handleAmeyoAgent}
        >
          Ameyo
        </div>
      )}

      {showAmeyoPanel && (
        <div
          style={{
            position: "fixed",
            right: 20,
            bottom: 30,
            height: "650px",
            width: "650px",
            backgroundColor: "transparent",
            borderTopLeftRadius: 10,
            borderTopRightRadius: 10,
            boxShadow: "0 10px 20px rgba(0,0,0,0.5)",
            zIndex: 99999,
            display: minimized ? "none" : "block",
          }}
        >
          <IoIosRemoveCircleOutline
            style={{
              position: "absolute",
              top: -10,
              right: -10,
              zIndex: 100000,
              color: "#ffffff",
              fontSize: "20px",
              cursor: "pointer",
              backgroundColor: "#111",
              borderRadius: "100%",
            }}
            onClick={handleMinimize}
          />
          <iframe
            ref={iframeRef}
            allow="camera;geolocation;microphone;autoplay"
            height="100%"
            width="100%"
            id="ameyoIframe"
            src={iframeUrl}
            style={{ border: "none" }}
          />
        </div>
      )}

      {showCallDispositionModal && (
        <CallDispositionModal
          open={showCallDispositionModal}
          onClose={() => setShowCallDispositionModal(false)}
          leadPhone={leadPhone}
        />
      )}
    </>
  );
};

export default AmeyoBot;
